import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative w-full py-24 md:py-32 px-4 md:px-6 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20dramatic%20background%20with%20overlapping%20geometric%20shapes%20in%20deep%20crimson%20and%20charcoal%20tones%2C%20luxurious%20velvet%20texture%2C%20elegant%20magazine%20spread%20style%2C%20dark%20moody%20atmosphere%20with%20warm%20highlights%2C%20abstract%20art%20with%20depth%2C%20clean%20minimal%20composition&width=1600&height=600&seq=cta-bg-home&orientation=landscape"
          alt=""
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-black/60"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto">
        <div className="md:max-w-lg">
          <h2 className="font-heading text-4xl md:text-6xl font-bold text-white leading-tight">
            不想错过
            <br />
            任何一个瓜？
          </h2>
          <Link
            to="/category/shehui"
            className="mt-8 inline-flex items-center gap-2 px-8 py-3 bg-background-50 text-foreground-950 rounded-full text-sm font-bold hover:bg-accent-400 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            立即浏览最新爆料
            <span className="w-6 h-6 flex items-center justify-center rounded-full bg-foreground-950 text-background-50">
              <i className="ri-arrow-right-line text-xs"></i>
            </span>
          </Link>
        </div>

        <div className="mt-20 md:mt-0 md:absolute md:bottom-10 md:right-6 md:text-right">
          <p className="text-white/70 text-sm leading-relaxed max-w-xs md:ml-auto">
            黑料吃瓜在线，你的每日吃瓜伴侣。娱乐圈、直播圈、网红圈，全网热点一网打尽。
          </p>
        </div>
      </div>
    </section>
  );
}